// 调查问卷相关路由
export default {
  routes: [
    // 验机订单问卷首页
    {
      path: '/(\\s*)questionSurvey(\\d*)/(\\s*)inspectMobile(\\d*)',
      name: 'questionSurveyInspectMobile',
      meta: {
        desc: '验机订单问卷首页'
      },
      component: () =>
        import(
          /* webpackChunkName: "questionSurveyInspectMobile" */ '../views/questionSurvey/inspectMobile/inspectMobile.vue'
        )
    },
    // 非验机订单问卷首页
    {
      path: '/(\\s*)questionSurvey(\\d*)/(\\s*)noInspectMobile(\\d*)',
      name: 'questionSurveyNoInspectMobile',
      meta: {
        desc: '非验机订单问卷首页'
      },
      component: () =>
        import(
          /* webpackChunkName: "questionSurveyNoInspectMobile" */ '../views/questionSurvey/noInspectMobile/noInspectMobile.vue'
        )
    }
  ]
}
